import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import {
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
  CircularProgress,
  Menu,
  Grid,
  TextField,
  IconButton,
  Typography,
  Box,
  Chip,
  Avatar,
  makeStyles,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormLabel,
  InputLabel,
  MenuItem,
  FormHelperText,
  Select,
  Tabs,
  Tab,
  Divider,
  InputAdornment
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Alert from '@material-ui/lab/Alert';
import {
  Close as CloseIcon,
  DirectionsCar as CarIcon,
  Build as BuildIcon,
  Speed as SpeedIcon,
  DateRange as DateIcon,
  VpnKey as VinIcon,
  LocalShipping as TruckIcon,
  Phone as PhoneIcon,
  Category as CategoryIcon,
  Business as BusinessIcon,
  Group as GroupIcon,
  Assignment as AssignmentIcon,
  LocationOn as LocationIcon,
  Warning as WarningIcon,
  Refresh as RefreshIcon,
  LocalGasStation as FuelIcon,
  BatteryChargingFull as BatteryIcon,
  Timer as TimerIcon,
  Opacity as OilIcon,
  AcUnit as TempIcon,
  Timeline as TimelineIcon,
  Search as SearchIcon
} from '@material-ui/icons';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';
import QRCode from 'qrcode';
import moment from 'moment';
import { Link, useHistory } from 'react-router-dom';
import AssignedEntityComponent from '../Entities/AssignedEntityComponent';
import PhotoUploadComponent from '../Uploads/PhotoUploadComponent';
import RepairComponent from './RepairsComponent';
import AddRepairButton from './NewRepair';
import EquipmentMaintenanceHistory from './MtcAndRepair/EquipmentMtcHistory'
import VehicleDamageViewer from './MtcAndRepair/VehicleDamageViewer';
import {
  formattedItem,
  
} from './KeyInputs'
import {
  TypesOfKeys
} from './AddEquipmentModal'

const useStyles = makeStyles(theme => ({
  dialogContent: {
    padding: theme.spacing(3),
  },
  header: {
    position: 'relative',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.primary.contrastText,
  },
  imageSection: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  mainImage: {
    width: 300,
    height: 200,
    objectFit: 'cover',
    borderRadius: theme.shape.borderRadius,
  },
  qrCode: {
    width: 120,
    height: 120,
  },
  statusChip: {
    marginTop: theme.spacing(1),
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  tabPanel: {
    padding: theme.spacing(2),
  },
  statsGrid: {
    marginBottom: theme.spacing(3),
  },
  statCard: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
  },
  statIcon: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(1),
    borderRadius: '50%',
  },
  fieldGroup: {
    marginBottom: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(3, 0),
  },
  grid: {
    margin: '10px',
    padding: '10px',
    width: '95%'
  },
  formControl: {
    margin: theme.spacing(3),
  },
}));

function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box className={other.className}>{children}</Box>}
    </div>
  );
}

const EquipmentModal = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(0);
  const [vehicleMakes, setVehicleMakes] = React.useState([]);
  const [vehicleModels, setVehicleModels] = React.useState([]);
  const [vehicleLoading, setVehicleLoading] = React.useState(false);

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: currentYear - 1979 }, (_, i) => (1980 + i).toString()).reverse();

  const fetchVehicleMakesByYear = async (year) => {
    if (!year) return;
    setVehicleLoading(true);
    try {
      const resp = await axios.post(`${props.url}/api/equipment/nhtsaapirequest`, { type: 'makesByYear', year });
      setVehicleMakes(resp?.data?.length ? resp.data : []);
    } catch (err) {
      console.error('Error fetching makes:', err);
      setVehicleMakes([]);
    } finally {
      setVehicleLoading(false);
    }
  };

  const fetchVehicleModelsByMakeYear = async (make, year) => {
    if (!make || !year) return;
    setVehicleLoading(true);
    try {
      const resp = await axios.post(`${props.url}/api/equipment/nhtsaapirequest`, { type: 'fetchModelsByMakeAndYear', make, year });
      if (resp?.data?.models?.length) {
        const seen = new Set();
        const unique = resp.data.models.filter(m => {
          if (seen.has(m.Model_ID)) return false;
          seen.add(m.Model_ID);
          return true;
        });
        setVehicleModels(unique);
      } else {
        setVehicleModels([]);
      }
    } catch (err) {
      console.error('Error fetching models:', err);
      setVehicleModels([]);
    } finally {
      setVehicleLoading(false);
    }
  };

  const equipmentTypes = [
    'Vehicle',
    'Trailer',
    'Mower',
    'Trimmer',
    'Jackhammer',
    'Cell Phone',
    'Tablet',
    'Key',
    'Keycard',
    'Other'
  ];

  const divisions = [
    'Customer Service',
    'Specialty',
    'Irrigation and Lighting',
    'Maintenance',
    'Landscape Install',
    'Hardscape',
    'Pool/Spa',
    'Yard',
    'Commercial',
    'ADOT',
    'Maricopa County'
  ];

  const [state, setState] = React.useState({
    equipment: {},
    isActive: false,
    assignedCrew: {},
    entity: {},
    qrCode: '',
    counter: 0,
    customQR: '',
    tankState: null,
    recentActivities: [],
    tankConfig: {
      cleanTankCapacity: 300,
      mixTankCapacity: 200,
      calibrationRate: 20
    },
    loadingTankData: false,
    showAllActivities: false,
    initialTankDataLoaded: false,
    // Diagnostics state
    diagnostics: null,
    diagnosticsHistory: [],
    loadingDiagnostics: false,
    refreshingDiagnostics: false,
    // Diagnostics history chart
    historyChartOpen: false,
    historyChartMetric: null,
    historyChartData: [],
    historyChartLoading: false,
    historyChartDateRange: null
  });

  React.useEffect(() => {
    if (props.equipment && props.equipment._id) {
      console.log('Set it', props.equipment)

      let newState = {
        equipment: props.equipment,
        isActive: props.equipment.isActive,
        initialTankDataLoaded: false,
        tankState: null,
        recentActivities: [],
        diagnostics: {}
      };

      if (props.equipment.crew) {
        let ourIndex = props.crews.map(function (e) {
          return e._id;
        }).indexOf(props.equipment.crew);
        newState.assignedCrew = props.crews[ourIndex];
      }

      setState(prev => ({
        ...prev,
        ...newState
      }));

      // Immediately fetch tank data if this is a spray truck
      if (props.equipment.isSprayTruck) {
        console.log('Equipment is spray truck, fetching tank data...');
        // Small delay to ensure state has updated
        setTimeout(() => {
          fetchTankDataForEquipment(props.equipment._id);
        }, 100);
      } else {
        console.log('Doublecheck...')
        setTimeout(() => {
          fetchTankDataForEquipment(props.equipment._id);
        }, 1000);
      }

      // Fetch diagnostics for vehicles with geoTabId
      if (props.equipment.type === 'Vehicle' && props.equipment.geoTabId) {
        fetchDiagnosticsData(props.equipment._id);
      }
    }
  }, [props.equipment?._id]);

  React.useEffect(() => {
    if (state.equipment && state.equipment._id) {
      let qrURL = `https://dflportal.com/qr/equipment/${state.equipment._id}`;
      var opts = {
        errorCorrectionLevel: 'H',
        type: 'image/png',
        quality: 0.5,
        margin: 3,
        color: {
          dark: "#000",
          light: "#FFF",
        }
      };
      QRCode.toDataURL(qrURL, opts, function (err, url) {
        if (err) throw err;
        setState({...state, qrCode: url, counter: state.counter++ });
      });
    }
  }, [state.equipment]);

  const fetchTankDataForEquipment = async (equipmentId) => {
    if (!equipmentId) {
      console.log('No equipment ID provided, skipping tank data fetch');
      return;
    }

    console.log('Fetching tank data for equipment:', equipmentId);
    setState(prev => ({ ...prev, loadingTankData: true }));

    try {
      // Fetch tank state
      const tankStateResponse = await axios.get(
        `${props.url}/api/equipment/getTankState?equipmentId=${equipmentId}`
      );

      // Fetch recent activities
      const activitiesResponse = await axios.get(
        `${props.url}/api/equipment/getTankActivities?equipmentId=${equipmentId}&limit=10`
      );

      const newState = {
        tankState: tankStateResponse.data.tankState,
        recentActivities: activitiesResponse.data.activities || [],
        loadingTankData: false,
        initialTankDataLoaded: true
      };

      // Update tank config from existing tank state (only on initial load)
      if (tankStateResponse.data.tankState && tankStateResponse.data.tankState.tanks) {
        const cleanTank = tankStateResponse.data.tankState.tanks.find(t => t.type === 'clean');
        const mixTank = tankStateResponse.data.tankState.tanks.find(t => t.type === 'mix');

        newState.tankConfig = {
          cleanTankCapacity: cleanTank?.maxCapacity || 300,
          mixTankCapacity: mixTank?.maxCapacity || 200,
          calibrationRate: tankStateResponse.data.tankState.calibrationRate || 20
        };

        console.log('Loaded existing tank state:', {
          cleanCapacity: cleanTank?.maxCapacity,
          cleanVolume: cleanTank?.currentVolume,
          mixCapacity: mixTank?.maxCapacity,
          mixVolume: mixTank?.currentVolume,
          calibrationRate: tankStateResponse.data.tankState.calibrationRate
        });
      } else {
        console.log('No tank state found for this equipment');
      }

      setState(prev => ({
        ...prev,
        ...newState
      }));
    } catch (error) {
      console.error('Error fetching tank data:', error);
      setState(prev => ({
        ...prev,
        loadingTankData: false,
        initialTankDataLoaded: true // Mark as loaded even on error to prevent retry loops
      }));
    }
  };

  const fetchTankData = async () => {
    return fetchTankDataForEquipment(state.equipment?._id);
  };

  // Helper to extract value from nested diagnostic object
  const getDiagValue = (field) => {
    if (field === null || field === undefined) return null;
    // If it's an object with a value property, extract it
    if (typeof field === 'object' && field.value !== undefined) {
      return field.value;
    }
    // Otherwise return the field directly (for backwards compatibility)
    return field;
  };

  const formatOurDiagData = (diagnosticData) => {
    if (!diagnosticData) return null;

    // Extract tire pressure values, with sanity check
    const getTirePressure = (tireData) => {
      const val = getDiagValue(tireData);
      if (val === null) return null;
      if (val > 1000) {
        return parseFloat(val / 1000)?.toFixed(2)
      }
      return val;
    };

    // Helper to get timestamp from raw data
    const getTimestamp = (field) => {
      if (!field) return null;
      return field.timestamp || null;
    };

    // Helper to calculate age in hours
    const getAgeHours = (timestamp) => {
      if (!timestamp) return null;
      return Math.round((Date.now() - new Date(timestamp)) / (1000 * 60 * 60));
    };

    const formatted = {
      ...diagnosticData,
      // Core metrics - values
      odometer: getDiagValue(diagnosticData?.odometer),
      engineHours: getDiagValue(diagnosticData?.engineHours),
      fuelLevel: getDiagValue(diagnosticData?.fuelLevel),
      oilLife: getDiagValue(diagnosticData?.oilLife),
      coolantTemp: getDiagValue(diagnosticData?.coolantTemp),
      oilPressure: getDiagValue(diagnosticData?.oilPressure),
      batteryVoltage: getDiagValue(diagnosticData?.batteryVoltage),
      electricalSystemRating: getDiagValue(diagnosticData?.electricalSystemRating),

      // Timestamps for each metric (for showing data freshness)
      timestamps: {
        odometer: getTimestamp(diagnosticData?.odometer),
        engineHours: getTimestamp(diagnosticData?.engineHours),
        fuelLevel: getTimestamp(diagnosticData?.fuelLevel),
        oilLife: getTimestamp(diagnosticData?.oilLife),
        coolantTemp: getTimestamp(diagnosticData?.coolantTemp),
        oilPressure: getTimestamp(diagnosticData?.oilPressure),
        batteryVoltage: getTimestamp(diagnosticData?.batteryVoltage),
        electricalSystemRating: getTimestamp(diagnosticData?.electricalSystemRating),
      },

      // Age in hours for quick staleness check
      ages: {
        odometer: getAgeHours(getTimestamp(diagnosticData?.odometer)),
        engineHours: getAgeHours(getTimestamp(diagnosticData?.engineHours)),
        fuelLevel: getAgeHours(getTimestamp(diagnosticData?.fuelLevel)),
        oilLife: getAgeHours(getTimestamp(diagnosticData?.oilLife)),
        coolantTemp: getAgeHours(getTimestamp(diagnosticData?.coolantTemp)),
        oilPressure: getAgeHours(getTimestamp(diagnosticData?.oilPressure)),
        batteryVoltage: getAgeHours(getTimestamp(diagnosticData?.batteryVoltage)),
        electricalSystemRating: getAgeHours(getTimestamp(diagnosticData?.electricalSystemRating)),
      },

      // Tire pressures - values and timestamps
      tirePressure: diagnosticData?.tirePressure ? {
        frontLeft: getTirePressure(diagnosticData.tirePressure.frontLeft),
        frontRight: getTirePressure(diagnosticData.tirePressure.frontRight),
        rearLeft: getTirePressure(diagnosticData.tirePressure.rearLeft),
        rearRight: getTirePressure(diagnosticData.tirePressure.rearRight),
        // Timestamps for tire pressures
        timestamps: {
          frontLeft: getTimestamp(diagnosticData.tirePressure.frontLeft),
          frontRight: getTimestamp(diagnosticData.tirePressure.frontRight),
          rearLeft: getTimestamp(diagnosticData.tirePressure.rearLeft),
          rearRight: getTimestamp(diagnosticData.tirePressure.rearRight),
        },
        // Get the most recent tire reading timestamp for display
        latestTimestamp: [
          getTimestamp(diagnosticData.tirePressure.frontLeft),
          getTimestamp(diagnosticData.tirePressure.frontRight),
          getTimestamp(diagnosticData.tirePressure.rearLeft),
          getTimestamp(diagnosticData.tirePressure.rearRight)
        ].filter(Boolean).sort((a, b) => new Date(b) - new Date(a))[0] || null
      } : null,

      // Keep original nested data
      _raw: diagnosticData
    };

    return formatted;
  };

  // Fetch vehicle diagnostics data
  const fetchDiagnosticsData = async (equipmentId) => {
    if (!equipmentId) return;
    console.log('[fetchDiagnosticsData', equipmentId)
    setState(prev => ({ ...prev, loadingDiagnostics: true }));

    try {
      const response = await axios.get(
        `${props.url}/api/equipment/${equipmentId}/diagnostics`
      );
        console.log('[fetchDiagnosticsData] response', response)
      if (response.data.success) {
        console.log('Set our diagnostics: ', response.data.diagnostics)
        console.log('or...', response.data.data)
        let formattedDiagnostics = formatOurDiagData(response.data.diagnostics)
        console.log('Formatted Diagnostics: ', formattedDiagnostics)
        setState(prev => ({
          ...prev,
          diagnostics: formattedDiagnostics, // response.data.diagnostics,
          loadingDiagnostics: false
        }));
      } else {
        setState(prev => ({ ...prev, loadingDiagnostics: false }));
      }
    } catch (error) {
      console.error('Error fetching diagnostics:', error);
      setState(prev => ({ ...prev, loadingDiagnostics: false }));
    }
  };

  // Refresh diagnostics from Geotab
  const handleRefreshDiagnostics = async () => {
    if (!state.equipment?._id) return;

    setState(prev => ({ ...prev, refreshingDiagnostics: true }));

    try {
      const response = await axios.post(
        `${props.url}/api/equipment/${state.equipment._id}/diagnostics/refresh`
      );

      if (response.data.success) {
        props.notification({
          type: 'success',
          title: 'Diagnostics Updated',
          message: 'Latest vehicle diagnostics fetched from Geotab'
        });
        // Refresh the displayed data
        await fetchDiagnosticsData(state.equipment._id);
      } else {
        props.notification({
          type: 'warning',
          title: 'Refresh Failed',
          message: response.data.error || 'Could not refresh diagnostics'
        });
      }
    } catch (error) {
      console.error('Error refreshing diagnostics:', error);
      props.notification({
        type: 'error',
        title: 'Error',
        message: 'Failed to refresh diagnostics from Geotab'
      });
    } finally {
      setState(prev => ({ ...prev, refreshingDiagnostics: false }));
    }
  };

  // Fetch diagnostics history for charts
  const fetchDiagnosticsHistory = async (equipmentId, fields = 'fuelLevel,batteryVoltage,odometer') => {
    if (!equipmentId) return;

    try {
      const response = await axios.get(
        `${props.url}/api/equipment/${equipmentId}/diagnostics/history`,
        { params: { fields, limit: 30 } }
      );

      if (response.data.success) {
        setState(prev => ({
          ...prev,
          diagnosticsHistory: response.data.history
        }));
      }
    } catch (error) {
      console.error('Error fetching diagnostics history:', error);
    }
  };

  // Metric configuration for history charts
  const metricConfig = {
    odometer: { label: 'Odometer', unit: 'mi', color: '#2196f3', icon: SpeedIcon },
    engineHours: { label: 'Engine Hours', unit: 'hrs', color: '#9c27b0', icon: TimerIcon },
    fuelLevel: { label: 'Fuel Level', unit: '%', color: '#4caf50', icon: FuelIcon, min: 0, max: 100, warning: 20 },
    batteryVoltage: { label: 'Battery Voltage', unit: 'V', color: '#ff9800', icon: BatteryIcon, min: 10, max: 16, warning: 12 },
    oilLife: { label: 'Oil Life', unit: '%', color: '#795548', icon: OilIcon, min: 0, max: 100, warning: 20 },
    coolantTemp: { label: 'Coolant Temp', unit: '°F', color: '#f44336', icon: TempIcon, warning: 230 },
    oilPressure: { label: 'Oil Pressure', unit: 'psi', color: '#607d8b', icon: OilIcon },
    electricalSystemRating: { label: 'Electrical System', unit: '%', color: '#00bcd4', icon: BatteryIcon, min: 0, max: 100, warning: 50 },
    tirePressureFrontLeft: { label: 'Tire Pressure (FL)', unit: 'psi', color: '#3f51b5', min: 20, max: 50 },
    tirePressureFrontRight: { label: 'Tire Pressure (FR)', unit: 'psi', color: '#3f51b5', min: 20, max: 50 },
    tirePressureRearLeft: { label: 'Tire Pressure (RL)', unit: 'psi', color: '#3f51b5', min: 20, max: 50 },
    tirePressureRearRight: { label: 'Tire Pressure (RR)', unit: 'psi', color: '#3f51b5', min: 20, max: 50 },
  };

  // Open history chart for a specific metric
  const handleOpenHistoryChart = async (metric) => {
    if (!state.equipment?._id) return;

    setState(prev => ({
      ...prev,
      historyChartOpen: true,
      historyChartMetric: metric,
      historyChartLoading: true,
      historyChartData: []
    }));

    try {
      const response = await axios.get(
        `${props.url}/api/equipment/${state.equipment._id}/diagnostics/readings`,
        { params: { metric, limit: 500 } }
      );

      if (response.data.success) {
        // Format data for recharts
        const chartData = (response.data.data || []).map(reading => ({
          timestamp: new Date(reading.timestamp).getTime(),
          value: reading.value,
          dateLabel: moment(reading.timestamp).format('MM/DD HH:mm')
        }));

        setState(prev => ({
          ...prev,
          historyChartData: chartData,
          historyChartDateRange: response.data.dateRange,
          historyChartLoading: false
        }));
      } else {
        setState(prev => ({ ...prev, historyChartLoading: false }));
      }
    } catch (error) {
      console.error('Error fetching metric history:', error);
      setState(prev => ({ ...prev, historyChartLoading: false }));
    }
  };

  // Close history chart
  const handleCloseHistoryChart = () => {
    setState(prev => ({
      ...prev,
      historyChartOpen: false,
      historyChartMetric: null,
      historyChartData: [],
      historyChartDateRange: null
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    let equip = state.equipment;
    let obj = { equipment: equip };

    try {
      // First update the equipment
      const equipmentResponse = await axios({
        method: 'post',
        url: `${props.url}/api/equipment/updateEquipment`,
        data: obj,
      });

      if (!equipmentResponse.data._id) {
        props.notification({
          type: 'warning',
          title: 'Uh Oh!',
          message: equipmentResponse.data.message
        });
        setLoading(false);
        return;
      }

      // If spray truck is enabled and we need to initialize tank state
      if (equip.isSprayTruck) {
        try {
          const tankResponse = await axios.post(
            `${props.url}/api/equipment/toggleSprayTruck`,
            {
              equipmentId: equip._id,
              isSprayTruck: true,
              tankConfig: state.tankConfig
            }
          );

          if (tankResponse.data.success) {
            // Reset the flag to allow fetching fresh data
            setState(prev => ({ ...prev, initialTankDataLoaded: false }));

            // Refresh tank data to show updated state
            await fetchTankData();

            props.notification({
              type: 'success',
              title: 'Equipment Updated!',
              message: state.tankState
                ? 'Spray truck configuration updated successfully'
                : 'Spray truck configuration saved successfully'
            });
          }
        } catch (tankError) {
          console.error('Error setting up tank state:', tankError);
          props.notification({
            type: 'warning',
            title: 'Partial Success',
            message: 'Equipment updated but tank setup failed. Please try again.'
          });
        }
      } else {
        props.notification({
          type: 'success',
          title: 'Saved Changes to that Equipment!',
          message: 'Well Done!!'
        });
      }

      props.updateParent('update', equipmentResponse.data);
      setLoading(false);
    } catch (err) {
      console.error('Error saving equipment:', err);
      props.notification({
        type: 'error',
        title: 'Error',
        message: 'Failed to save equipment'
      });
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    console.log('Close modal - can we change url??', props)
    props.updateParent('closeModal');
  };


  const updateEquipmentDivision = (event, value) => {
    setState({...state, equipment: {...state.equipment, division: value}});
  };

  const updateEquipmentType = (event, value) => {
    setState({...state, equipment: {...state.equipment, type: value}});
  };


  const handleSearchPlate = async () => {
    console.log('handleSearchPlate...', state.equipment.plate)
    
    try {
      const response = await axios.post(
        `${props.url}/api/equipment/plate-search`,
        {
          plateNumber: state.equipment.plate
        }
      );
        console.log('response', response)
      if (response.data?.success) {
        if (response.data.equipment) {
          props.notification({
            type: 'success',
            title: 'Plate Search',
            message: 'Equipment details found by plate search. Please verify'
          });
          let updatedEquipment = {...state.equipment, 
            ...response.data.equipment
          
          }
          console.log('Update our equipment', updatedEquipment)
          setState({...state, equipment: updatedEquipment });
        } else {
          props.notification({
            type: 'warning',
            title: 'Plate Search Failed',
            message: `Unable to find a matching vehicle for that plate number (${state.equipment.plate})`
          });
        }
      } else {
        console.log('Error??', response)
      }
    } catch (e) {
      console.log('Handle search plate error', e)
    }
  }

  const clearSearch = () => {
    console.log('clearPlateSearch...')
  }

  const updateAssignedCrew = (event, crew) => {
    console.log(crew)
    if (crew && crew._id) {
      setState({
        ...state,
        assignedCrew: crew,
        equipment: {
          ...state.equipment,
          crew: crew._id,
          crewName: crew.name,
          checkedOutTo: crew?.foreman || null,
          checkedOutToName: crew?.foremanName || '',
          isCheckedOut: true,
          lastCheckOutTime: new Date(),
          updated_at: new Date(),
        }
      });
    } else {
      setState({
        ...state,
        assignedCrew: {},
        equipment: {
          ...state.equipment,
          crew: null,
          crewName: 'None',
          checkedOutTo: null,
          checkedOutToName: null,
          isCheckedOut: false,
          updated_at: new Date()
        }
      });
    }
  };

  const handleUpdateAssignedEntity = (newEntity) => {
    if (newEntity && newEntity._id) {
      setState({...state, equipment: {...state.equipment, entity: newEntity._id }});
    } else {
      setState({...state, equipment: {...state.equipment, entity: null }});
    }
  };

  const handleUpdateResponse = (resp) => {
    if (resp && resp.filesUploaded && resp.filesUploaded.length) {
      let ourFile = resp.filesUploaded[0];
      let item = {...state.equipment};
      item.pictureURL = ourFile.url;
      setState({...state, equipment: item });
    }
  };

  const handleChangeStatus = (e) => {
    setState({...state, equipment: {...state.equipment, status: e.target.value }});
  };

  const handleAddRepair = (data) => {
    console.log('Add Repair..', data);
  };

  const handleLogMtc = () => {
    const route = `/vehiclemaintenance/${state.equipment._id}`;
    history.push({ pathname: route, props: { equipment: state.equipment }});
  };

  const handleToggleSprayTruck = async (isChecked) => {
    if (isChecked) {
      // User is enabling spray truck - we'll save tank config when they hit save
      setState({
        ...state,
        equipment: {
          ...state.equipment,
          isSprayTruck: true
        }
      });
    } else {
      // User is disabling spray truck - call API immediately
      try {
        const response = await axios.post(
          `${props.url}/api/equipment/toggleSprayTruck`,
          {
            equipmentId: state.equipment._id,
            isSprayTruck: false
          }
        );

        if (response.data.success) {
          props.notification({
            type: 'success',
            title: 'Spray Truck Deactivated',
            message: 'Equipment is no longer designated as a spray truck'
          });

          setState({
            ...state,
            equipment: {
              ...state.equipment,
              isSprayTruck: false
            },
            tankState: null,
            recentActivities: []
          });
        }
      } catch (error) {
        console.error('Error deactivating spray truck:', error);
        props.notification({
          type: 'error',
          title: 'Error',
          message: 'Failed to deactivate spray truck'
        });
      }
    }
  };

  const handleTankConfigChange = (field, value) => {
    setState({
      ...state,
      tankConfig: {
        ...state.tankConfig,
        [field]: parseFloat(value) || 0
      }
    });
  };
console.log('STATE 661:: ', state)

const renderVehicleFields = () => (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4} md={4} lg={4}>
        <Autocomplete
          freeSolo
          options={yearOptions}
          value={state.equipment.year ? String(state.equipment.year) : ''}
          onChange={(e, newValue) => {
            const year = newValue || '';
            setState({...state, equipment: {...state.equipment, year, manufacturer: '', model: ''}});
            setVehicleMakes([]);
            setVehicleModels([]);
            if (year) fetchVehicleMakesByYear(year);
          }}
          onInputChange={(e, newInput, reason) => {
            if (reason === 'input') {
              setState(prev => ({...prev, equipment: {...prev.equipment, year: newInput}}));
              if (newInput.length === 4 && yearOptions.includes(newInput)) {
                fetchVehicleMakesByYear(newInput);
              }
            }
            if (reason === 'clear') {
              setState(prev => ({...prev, equipment: {...prev.equipment, year: '', manufacturer: '', model: ''}}));
              setVehicleMakes([]);
              setVehicleModels([]);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Year"
              placeholder="Type or select year"
              helperText={vehicleLoading && !vehicleMakes.length ? 'Loading makes...' : ''}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4}>
        <Autocomplete
          freeSolo
          options={vehicleMakes.map(m => m.MakeName)}
          value={state.equipment.manufacturer || ''}
          loading={vehicleLoading && vehicleMakes.length === 0 && !!state.equipment.year}
          disabled={!state.equipment.year}
          onChange={(e, newValue) => {
            const manufacturer = newValue || '';
            setState({...state, equipment: {...state.equipment, manufacturer, model: ''}});
            setVehicleModels([]);
            if (manufacturer && state.equipment.year) {
              fetchVehicleModelsByMakeYear(manufacturer, state.equipment.year);
            }
          }}
          onInputChange={(e, newInput, reason) => {
            if (reason === 'input') {
              setState(prev => ({...prev, equipment: {...prev.equipment, manufacturer: newInput}}));
            }
            if (reason === 'clear') {
              setState(prev => ({...prev, equipment: {...prev.equipment, manufacturer: '', model: ''}}));
              setVehicleModels([]);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Manufacturer"
              placeholder={state.equipment.year ? 'Type or select make' : 'Select a year first'}
              helperText={vehicleLoading && !vehicleModels.length && state.equipment.manufacturer ? 'Loading models...' : ''}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4}>
        <Autocomplete
          freeSolo
          options={vehicleModels.map(m => m.Model_Name)}
          value={state.equipment.model || ''}
          loading={vehicleLoading && vehicleModels.length === 0 && !!state.equipment.manufacturer}
          disabled={!state.equipment.manufacturer}
          onChange={(e, newValue) => {
            setState({...state, equipment: {...state.equipment, model: newValue || ''}});
          }}
          onInputChange={(e, newInput, reason) => {
            if (reason === 'input') {
              setState(prev => ({...prev, equipment: {...prev.equipment, model: newInput}}));
            }
            if (reason === 'clear') {
              setState(prev => ({...prev, equipment: {...prev.equipment, model: ''}}));
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Model"
              placeholder={state.equipment.manufacturer ? 'Type or select model' : 'Select a make first'}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={3} md={4} lg={4}>
        <TextField
          fullWidth
          label="License Plate"
          value={state.equipment.plate || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, plate: e.target.value}})}
          helperText={`Input Plate Number to Look-Up VIN/MFG Details`}
          InputProps={{
            // startAdornment: (
            //   <InputAdornment position="start">
            //     <SearchIcon />
            //   </InputAdornment>
            // ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  arial-label="search"
                   onClick={handleSearchPlate}
                   size="small"
                  >
                    <SearchIcon />
                    </IconButton>
              </InputAdornment>
            )
          }}

        />
      </Grid>
      <Grid item xs={12} sm={6}  md={6} lg={6}>
        <TextField
          fullWidth
          label="VIN"
          value={state.equipment.vin || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, vin: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12} sm={3} md={4} lg={4}>
        <TextField
          fullWidth
          label="Geotab ID"
          value={state.equipment.geoTabId || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, geoTabId: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4}>
        <TextField
          fullWidth
          label="Mileage"
          value={state.equipment.mileage || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, mileage: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4}>
        <TextField
          fullWidth
          disabled
          label="Next Service Mileage"
          value={state.equipment.nextServiceMileage || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, nextServiceMileage: e.target.value}})}
        />
      </Grid>
      

      {/* ============== Spray Truck Section ============== */}
      <Grid item xs={12}>
        <Divider style={{ margin: '16px 0' }} />
        <Typography variant="h6" style={{ marginBottom: 8 }}>
          Spray Truck Configuration
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
          Enabling spray truck will create Clean and Mix tanks for this vehicle
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={state.equipment.isSprayTruck || false}
              onChange={(e) => handleToggleSprayTruck(e.target.checked)}
              name="isSprayTruck"
              color="primary"
            />
          }
          label="Designate as Spray Truck"
        />
      </Grid>

      {state.equipment.isSprayTruck && (
        <>
          <Grid item xs={12}>
            <Box p={2} border={1} borderRadius={4} borderColor="primary.main" bgcolor="rgba(63, 81, 181, 0.05)">
              <Typography variant="subtitle1" gutterBottom color="primary">
                Tank Capacities & Calibration
              </Typography>
              <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                {state.tankState
                  ? 'Update tank capacities or calibration rate for this spray truck'
                  : 'Configure the max capacity for Clean and Mix tanks (both start empty)'}
              </Typography>
              {state.tankState && (
                <Chip
                  label="Tanks Already Configured"
                  size="small"
                  color="primary"
                  style={{ marginBottom: 8 }}
                />
              )}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Clean Tank Capacity (gal)"
                    type="number"
                    value={state.tankConfig.cleanTankCapacity}
                    onChange={(e) => handleTankConfigChange('cleanTankCapacity', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Mix Tank Capacity (gal)"
                    type="number"
                    value={state.tankConfig.mixTankCapacity}
                    onChange={(e) => handleTankConfigChange('mixTankCapacity', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Calibration Rate (gal/acre)"
                    type="number"
                    value={state.tankConfig.calibrationRate}
                    onChange={(e) => handleTankConfigChange('calibrationRate', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Current Tank Status */}
          <Grid item xs={12}>
            <Box p={2} border={1} borderRadius={4} borderColor="grey.300">
              <Typography variant="subtitle1" gutterBottom>
                Current Tank Status
              </Typography>
              {state.loadingTankData ? (
                <Box display="flex" alignItems="center" justifyContent="center" p={3}>
                  <CircularProgress size={24} />
                  <Typography variant="body2" color="textSecondary" style={{ marginLeft: 12 }}>
                    Loading tank status...
                  </Typography>
                </Box>
              ) : state.tankState && state.tankState.tanks ? (
                <Grid container spacing={2}>
                  {state.tankState.tanks.map((tank, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <Paper elevation={1} style={{ padding: 12 }}>
                        <Typography variant="caption" color="textSecondary">
                          {tank.type === 'clean' ? 'Clean Tank' : 'Mix Tank'}
                        </Typography>
                        <Typography variant="h6">
                          {tank.currentVolume.toFixed(1)} / {tank.maxCapacity} gal
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          ({((tank.currentVolume / tank.maxCapacity) * 100).toFixed(1)}% full)
                        </Typography>
                        {tank.hasChemicals && (
                          <Chip
                            label="Contains Chemicals"
                            size="small"
                            color="secondary"
                            style={{ marginTop: 4 }}
                          />
                        )}
                        {tank.contents?.filter(c => c.type === 'chemical').length > 0 && (
                          <Box mt={1}>
                            <Typography variant="caption" color="textSecondary">
                              Chemicals:
                            </Typography>
                            {tank.contents
                              .filter(c => c.type === 'chemical')
                              .map((chem, i) => (
                                <Typography key={i} variant="body2">
                                  • {chem.chemicalName} ({(chem.concentration || 0).toFixed(2)}%)
                                </Typography>
                              ))}
                          </Box>
                        )}
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No tank data available yet. Save this configuration to initialize tanks.
                </Typography>
              )}
            </Box>
          </Grid>

          {/* Recent Activities */}
          {(state.recentActivities.length > 0 || state.tankState) && (
            <Grid item xs={12}>
              <Box p={2} border={1} borderRadius={4} borderColor="grey.300">
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <Typography variant="subtitle1">
                    Recent Tank Activities
                  </Typography>
                  {state.recentActivities.length > 0 && (
                    <Button
                      size="small"
                      color="primary"
                      onClick={() => setState({ ...state, showAllActivities: true })}
                    >
                      View All
                    </Button>
                  )}
                </Box>
                {state.recentActivities.length > 0 ? (
                  state.recentActivities.slice(0, 5).map((activity, index) => (
                    <Box key={index} py={1} borderBottom={index < 4 ? '1px solid #eee' : 'none'}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="caption" color="textSecondary">
                            {moment(activity.timestamp).format('MMM DD, h:mm A')}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="body2">
                            {activity.employee}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2">
                            {activity.details}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No tank activities recorded yet. Activities will appear here after tank operations.
                  </Typography>
                )}
              </Box>
            </Grid>
          )}
        </>
      )}
    </Grid>
  );

  const renderKeyFields = () => {
    // Render additional fields based on keyType
    const renderKeyTypeFields = () => {
      switch (state.equipment.keyType) {
        case 'Vehicle':
          return (
            <Grid item xs={12}>
              <Autocomplete
                id="vehicle-select"
                options={props?.equipmentList?.filter(item => item?.type === 'Vehicle') || []}
                getOptionLabel={(option) => formattedItem('vehicle', option)}
                value={state.equipment.keyForEquipment || null}
                onChange={(e, newValue) => setState({
                  ...state, 
                  equipment: {
                    ...state.equipment,
                    keyForEquipment: newValue
                  }
                })}
                renderInput={(params) => <TextField {...params} label="Select Vehicle" variant="outlined" />}
              />
            </Grid>
          );
        
        case 'Equipment':
          return (
            <Grid item xs={12}>
              <Autocomplete
                id="equipment-select"
                options={props?.equipmentList?.filter(item => item?.type !== 'Vehicle') || []}
                getOptionLabel={(option) => formattedItem('equipment', option)}
                value={state.equipment.keyForEquipment || null}
                onChange={(e, newValue) => setState({
                  ...state, 
                  equipment: {
                    ...state.equipment,
                    keyForEquipment: newValue
                  }
                })}
                renderInput={(params) => <TextField {...params} label="Select Equipment" variant="outlined" />}
              />
            </Grid>
          );
        
        case 'Customer Building':
          return (
            <Grid item xs={12}>
              <Autocomplete
                id="jobsite-select"
                options={props?.jobSites || []}
                getOptionLabel={(option) =>formattedItem('jobSite', option)}
                value={state.equipment.keyForJobSite || null}
                onChange={(e, newValue) => setState({
                  ...state, 
                  equipment: {
                    ...state.equipment,
                    keyForJobSite: newValue
                  }
                })}
                renderInput={(params) => <TextField {...params} label="Select Customer Building" variant="outlined" />}
              />
            </Grid>
          );
        
        case 'Company Building':
          return (
            <Grid item xs={12}>
              <TextField
                id="company-building"
                label="Company Building"
                variant="outlined"
                fullWidth
                value={state.equipment.keyDetails || ''}
                onChange={(e) => setState({
                  ...state, 
                  equipment: {
                    ...state.equipment,
                    keyDetails: e.target.value
                  }
                })}
              />
            </Grid>
          );
        
        case 'Other':
          return (
            <Grid item xs={12}>
              <TextField
                id="other-details"
                label="Other Details"
                variant="outlined"
                multiline
                rows={3}
                fullWidth
                value={state.equipment.keyDetails || ''}
                onChange={(e) => setState({
                  ...state, 
                  equipment: {
                    ...state.equipment,
                    keyDetails: e.target.value
                  }
                })}
              />
            </Grid>
          );
        
        default:
          return null;
      }
    };
  
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Autocomplete
            id="KeyType"
            options={TypesOfKeys}
            onChange={(e, newOpt) => setState({
              ...state, 
              equipment: {
                ...state.equipment, 
                keyType: newOpt
              }
            })}
            value={state.equipment.keyType || ''}
            renderInput={(params) => <TextField {...params} label="Key Type" variant="outlined" />}
          />
        </Grid>
        
        {state.equipment.keyType && renderKeyTypeFields()}
        
        <Grid item xs={12}>
          <TextField
            id="notes"
            label="Notes"
            variant="outlined"
            multiline
            rows={2}
            fullWidth
            value={state.equipment.notes || ''}
            onChange={(e) => setState({
              ...state, 
              equipment: {
                ...state.equipment,
                notes: e.target.value
              }
            })}
          />
        </Grid>
      </Grid>
    );
  };

  const renderPhoneFields = () => (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Phone Number"
          value={state.equipment.phoneNumber || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, phoneNumber: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="IMEI"
          value={state.equipment.imei || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, imei: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="MAC Address"
          value={state.equipment.mac || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, mac: e.target.value}})}
        />
      </Grid>
    </Grid>
  );

  // Tank Activities Modal Component
  const TankActivitiesModal = () => {
    const [allActivities, setAllActivities] = React.useState([]);
    const [loadingAll, setLoadingAll] = React.useState(false);
    const [pagination, setPagination] = React.useState({ total: 0, limit: 50, skip: 0 });

    React.useEffect(() => {
      if (state.showAllActivities && state.equipment._id) {
        loadAllActivities();
      }
    }, [state.showAllActivities]);

    const loadAllActivities = async (skip = 0) => {
      setLoadingAll(true);
      try {
        const response = await axios.get(
          `${props.url}/api/equipment/getTankActivities?equipmentId=${state.equipment._id}&limit=50&skip=${skip}`
        );

        setAllActivities(response.data.activities || []);
        setPagination(response.data.pagination);
        setLoadingAll(false);
      } catch (error) {
        console.error('Error loading all activities:', error);
        setLoadingAll(false);
      }
    };

    const handlePageChange = (newSkip) => {
      loadAllActivities(newSkip);
    };

    return (
      <Dialog
        open={state.showAllActivities}
        onClose={() => setState({ ...state, showAllActivities: false })}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          All Tank Activities - {state.equipment.name}
        </DialogTitle>
        <DialogContent>
          {loadingAll ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {allActivities.length === 0 ? (
                <Typography color="textSecondary">No activities found</Typography>
              ) : (
                <Box>
                  {allActivities.map((activity, index) => (
                    <Paper
                      key={index}
                      elevation={1}
                      style={{ padding: 12, marginBottom: 8 }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="caption" color="textSecondary">
                            Date/Time
                          </Typography>
                          <Typography variant="body2">
                            {moment(activity.timestamp).format('MMM DD, YYYY h:mm A')}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="caption" color="textSecondary">
                            Employee
                          </Typography>
                          <Typography variant="body2">
                            {activity.employee}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="caption" color="textSecondary">
                            Activity
                          </Typography>
                          <Typography variant="body2">
                            {activity.details}
                          </Typography>
                        </Grid>
                        {activity.location && (
                          <Grid item xs={12}>
                            <Typography variant="caption" color="textSecondary">
                              Location: {activity.location.coordinates?.[1]?.toFixed(6)}, {activity.location.coordinates?.[0]?.toFixed(6)}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    </Paper>
                  ))}

                  {/* Pagination */}
                  {pagination.total > pagination.limit && (
                    <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                      <Button
                        disabled={pagination.skip === 0}
                        onClick={() => handlePageChange(Math.max(0, pagination.skip - pagination.limit))}
                      >
                        Previous
                      </Button>
                      <Typography variant="body2" style={{ margin: '0 16px' }}>
                        Showing {pagination.skip + 1} - {Math.min(pagination.skip + pagination.limit, pagination.total)} of {pagination.total}
                      </Typography>
                      <Button
                        disabled={!pagination.hasMore}
                        onClick={() => handlePageChange(pagination.skip + pagination.limit)}
                      >
                        Next
                      </Button>
                    </Box>
                  )}
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setState({ ...state, showAllActivities: false })}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <>
      <TankActivitiesModal />
    <Dialog fullScreen open={props.open} onClose={handleCloseModal}>
      <Box className={classes.header}>
        <IconButton className={classes.closeButton} onClick={handleCloseModal}>
          <CloseIcon />
        </IconButton>
        <Box className={classes.headerContent}>
          <CategoryIcon fontSize="large" />
          <Box>
            <Typography variant="h5">
              {state.equipment.name || 'Equipment Details'}
            </Typography>
            <Typography variant="subtitle1">
              #{state.equipment.number}
            </Typography>
          </Box>
        </Box>
      </Box>

      <DialogContent className={classes.dialogContent}>
        {/* Fault Code Alert Banner */}
        {state.diagnostics?.activeFaultCount > 0 && (
          <Alert
            severity="warning"
            icon={<WarningIcon />}
            style={{ marginBottom: 16 }}
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  // Calculate the correct tab index for diagnostics
                  const diagTabIndex = state.equipment.type === 'Key' ? -1 : 4;
                  setTabValue(diagTabIndex);
                }}
              >
                View Details
              </Button>
            }
          >
            <strong>{state.diagnostics.activeFaultCount} Active Fault Code{state.diagnostics.activeFaultCount > 1 ? 's' : ''} Detected</strong>
            {state.diagnostics.activeFaultCodes?.slice(0, 2).map((fault, i) => (
              <Typography key={i} variant="body2" component="span" style={{ marginLeft: 8 }}>
                {fault.code}
              </Typography>
            ))}
            {state.diagnostics.activeFaultCodes?.length > 2 && (
              <Typography variant="body2" component="span" style={{ marginLeft: 8 }}>
                +{state.diagnostics.activeFaultCodes.length - 2} more
              </Typography>
            )}
          </Alert>
        )}

        <Grid container spacing={3}>
          {/* Left Column */}
          <Grid item xs={12} md={4}>
            <Paper className={classes.section}>
              <Box p={2}>
                <PhotoUploadComponent
                  message="Click Here to Add a Photo (Or Drop Image File Here)"
                  equipment={state.equipment}
                  updateParent={handleUpdateResponse}
                />
                <Box className={classes.imageSection}>
                  {state.equipment.pictureURL && (
                    <img
                      src={state.equipment.pictureURL}
                      alt={state.equipment.name}
                      className={classes.mainImage}
                    />
                  )}
                  {state.qrCode && (
                    <img
                      src={state.qrCode}
                      alt="QR Code"
                      className={classes.qrCode}
                    />
                  )}
                </Box>
                
                <TextField
                  select
                  fullWidth
                  label="Status"
                  value={state.equipment.status || ''}
                  onChange={handleChangeStatus}
                  variant="outlined"
                >
                  <MenuItem value="In Service">In Service</MenuItem>
                  <MenuItem value="Out for Repair">Out for Repair</MenuItem>
                  <MenuItem value="On Customer Site">On Customer Site</MenuItem>
                  <MenuItem value="On Loan">On Loan</MenuItem>
                </TextField>

                <Box className={classes.statCard} mt={2}>
                  <Avatar className={classes.statIcon}>
                    <SpeedIcon />
                  </Avatar>
                  <Box>
                    <Typography variant="body2" color="textSecondary">
                      Current Mileage
                    </Typography>
                    <Typography variant="h6">
                      {state.equipment.mileage?.toLocaleString() || '0'} mi
                    </Typography>
                  </Box>
                </Box>
                <Box mt={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    startIcon={<AssignmentIcon />}
                    onClick={handleLogMtc}
                    style={{ marginTop: 16 }}
                  >
                    Log Maintenance
                  </Button>
                  
                  <Box mt={1}>
                    <AddRepairButton 
                      equipmentId={state?.equipment._id} 
                      equipmentName={state?.equipment.name}
                      onAddRepair={handleAddRepair}
                    />
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper className={classes.section}>
              <Box p={2}>
                <Typography variant="h6" className={classes.sectionTitle}>
                  <BusinessIcon />
                  Organization
                </Typography>
                
                <Autocomplete
                  fullWidth
                  options={divisions}
                  value={state.equipment.division}
                  onChange={updateEquipmentDivision}
                  renderInput={(params) => (
                    <TextField {...params} label="Division" variant="outlined" />
                  )}
                />

                <Box mt={2}>
                  <Autocomplete
                    fullWidth
                    options={props.crews}
                    getOptionLabel={(option) => {
                      if (option?.name) {
                        return `${option.name}${option?.foremanName ? `(${option.foremanName})` : ''}`
                      } else {
                        return null
                      }
                    }}
                    value={state.assignedCrew}
                    onChange={updateAssignedCrew}
                    renderInput={(params) => (
                      <TextField {...params} label="Assigned Crew" variant="outlined" />
                    )}
                  />
                </Box>

                <Box mt={2}>
                  <AssignedEntityComponent 
                    entity={state.equipment.entity} 
                    title={'Assigned Entity'} 
                    disabled={loading} 
                    user={props.user} 
                    updateParent={handleUpdateAssignedEntity} 
                  />
                </Box>
              </Box>
            </Paper>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={8}>
            <Paper>

              <Tabs
                value={tabValue}
                onChange={(e, newValue) => setTabValue(newValue)}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="Details" />
               { state.equipment.type !== 'Key' && <Tab label="Repair History" /> }
               { state.equipment.type !== 'Key' && <Tab label="Maintenance History" /> }
                { state.equipment.type !== 'Key' && <Tab label="Damage History" /> }
                { state.equipment.type === 'Vehicle' && state.equipment.geoTabId && (
                  <Tab
                    label={
                      <Box display="flex" alignItems="center">
                        Diagnostics
                        {state.diagnostics?.activeFaultCount > 0 && (
                          <Chip
                            size="small"
                            label={state.diagnostics.activeFaultCount}
                            color="secondary"
                            style={{ marginLeft: 8, height: 20, minWidth: 20 }}
                          />
                        )}
                      </Box>
                    }
                  />
                )}
                <Tab label="Notes & Settings" />
              </Tabs>

              <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
                <Box className={classes.fieldGroup}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    <CategoryIcon />
                    Basic Information
                  </Typography>
                  
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Equipment Name"
                        value={state.equipment.name || ''}
                        onChange={(e) => setState({...state, equipment: {...state.equipment, name: e.target.value}})}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        fullWidth
                        options={equipmentTypes}
                        value={state.equipment.type}
                        onChange={updateEquipmentType}
                        renderInput={(params) => (
                          <TextField {...params} label="Equipment Type" variant="outlined" />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Box className={classes.fieldGroup}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    {state.equipment.type === 'Vehicle' ? <CarIcon /> : 
                     state.equipment.type === 'Cell Phone' ? <PhoneIcon /> : 
                     <BuildIcon />}
                    Equipment Details
                  </Typography>
                  
                  {(state?.equipment?.type === 'Trailer' || state.equipment.type === 'Vehicle') && renderVehicleFields()}
                  {state.equipment.type === 'Cell Phone' && renderPhoneFields()}
                  {state.equipment.type === 'Key' && renderKeyFields()}
                </Box>

                <Box className={classes.fieldGroup}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    <LocationIcon />
                    Location Information
                  </Typography>
                  <TextField
                    fullWidth
                    label="Location"
                    value={state.equipment.location || ''}
                    onChange={(e) => setState({...state, equipment: {...state.equipment, location: e.target.value}})}
                  />
                </Box>
              </TabPanel>

              <TabPanel value={tabValue} index={1} className={classes.tabPanel}>
                {(state.equipment._id && state.equipment.type !== 'Key') && (
                  <RepairComponent equipmentId={state.equipment._id} url={props.url} equipmentName={state.equipment.name} />
                )}
              </TabPanel>
              <TabPanel value={tabValue} index={2} className={classes.tabPanel}>
              {state.equipment._id && (
                  <EquipmentMaintenanceHistory 
                    equipmentId={state.equipment._id}
                    url={props.url}
                    perms={props.user?.permissions || []}
                  />
                )}
              </TabPanel>
              <TabPanel value={tabValue} index={3} className={classes.tabPanel}>
              {state.equipment._id && (
                  <VehicleDamageViewer
                    equipmentId={state.equipment._id}
                    url={props.url}
                  />
                )}
              </TabPanel>

              {/* Diagnostics Tab - Only for Vehicles with Geotab */}
              {state.equipment.type === 'Vehicle' && state.equipment.geoTabId && (
                <TabPanel value={tabValue} index={4} className={classes.tabPanel}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h6" className={classes.sectionTitle}>
                      <SpeedIcon />
                      Vehicle Diagnostics
                    </Typography>
                    <Button
                      variant="outlined"
                      color="primary"
                      startIcon={state.refreshingDiagnostics ? <CircularProgress size={16} /> : <RefreshIcon />}
                      onClick={handleRefreshDiagnostics}
                      disabled={state.refreshingDiagnostics}
                    >
                      {state.refreshingDiagnostics ? 'Refreshing...' : 'Refresh from Geotab'}
                    </Button>
                  </Box>

                  {state.loadingDiagnostics ? (
                    <Box display="flex" justifyContent="center" p={4}>
                      <CircularProgress />
                    </Box>
                  ) : state.diagnostics ? (
                    <>
                      {/* Last Updated */}
                      <Typography variant="caption" color="textSecondary" gutterBottom>
                        Last Updated: {moment(state.diagnostics.capturedAt).format('MMM DD, YYYY h:mm A')}
                        {' '}({moment(state.diagnostics.capturedAt).fromNow()})
                      </Typography>

                      {/* Fault Codes Section */}
                      {state.diagnostics.activeFaultCount > 0 && (
                        <Box mt={2} mb={3}>
                          <Alert severity="error" icon={<WarningIcon />}>
                            <Typography variant="subtitle2" gutterBottom>
                              Active Fault Codes ({state.diagnostics.activeFaultCount})
                            </Typography>
                            {state.diagnostics.activeFaultCodes?.map((fault, index) => (
                              <Box key={index} mt={1} p={1} bgcolor="rgba(0,0,0,0.03)" borderRadius={1}>
                                <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
                                  {/* OBD Code - prominent display */}
                                  {fault.obdCode && (
                                    <Chip
                                      label={fault.obdCode}
                                      size="small"
                                      color="secondary"
                                      style={{ fontWeight: 'bold', fontFamily: 'monospace' }}
                                    />
                                  )}
                                  {/* Severity chip */}
                                  {fault.severity && (
                                    <Chip
                                      label={fault.severity}
                                      size="small"
                                      variant="outlined"
                                      style={{
                                        borderColor: fault.severity === 'MaintenanceOnly' ? '#ff9800' : '#f44336',
                                        color: fault.severity === 'MaintenanceOnly' ? '#ff9800' : '#f44336'
                                      }}
                                    />
                                  )}
                                  {/* Risk of breakdown */}
                                  {fault.riskOfBreakdown != null && (
                                    <Typography variant="caption" color="textSecondary">
                                      Risk: {fault.riskOfBreakdown.toFixed(1)}%
                                    </Typography>
                                  )}
                                </Box>
                                <Typography variant="body2" style={{ marginTop: 4 }}>
                                  <strong>{fault.description || 'Unknown fault'}</strong>
                                </Typography>
                                {/* Recommendation */}
                                {fault.recommendation && (
                                  <Typography variant="caption" color="textSecondary" display="block" style={{ marginTop: 4 }}>
                                    <em>{fault.recommendation}</em>
                                  </Typography>
                                )}
                                {/* Timestamps - First/Last Seen */}
                                <Box display="flex" flexWrap="wrap" gap={2} mt={1}>
                                  <Typography variant="caption" color="textSecondary">
                                    First: {moment(fault.firstSeen).format('MMM DD, h:mm A')}
                                  </Typography>
                                  {fault.lastSeen && fault.lastSeen !== fault.firstSeen && (
                                    <Typography variant="caption" color="textSecondary">
                                      Last: {moment(fault.lastSeen).format('MMM DD, h:mm A')}
                                    </Typography>
                                  )}
                                  {fault.timesLogged > 1 && (
                                    <Typography variant="caption" style={{ color: '#f44336' }}>
                                      Logged {fault.timesLogged}x
                                    </Typography>
                                  )}
                                </Box>
                              </Box>
                            ))}
                          </Alert>
                        </Box>
                      )}

                      {/* Diagnostics Grid */}
                      <Grid container spacing={2}>
                        {/* Odometer */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Paper
                            elevation={1}
                            style={{ padding: 16, cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                            onClick={() => handleOpenHistoryChart('odometer')}
                            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'}
                            onMouseOut={(e) => e.currentTarget.style.boxShadow = ''}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                              <Box display="flex" alignItems="center">
                                <SpeedIcon color="primary" style={{ marginRight: 8 }} />
                                <Typography variant="subtitle2">Odometer</Typography>
                              </Box>
                              <Box display="flex" alignItems="center">
                                {state.diagnostics.ages?.odometer != null && (
                                  <Typography
                                    variant="caption"
                                    style={{
                                      color: state.diagnostics.ages.odometer > 24 ? '#ff9800' : '#9e9e9e',
                                      fontSize: '0.7rem',
                                      marginRight: 4
                                    }}
                                  >
                                    {state.diagnostics.ages.odometer}h ago
                                  </Typography>
                                )}
                                <TimelineIcon style={{ fontSize: 14, color: '#9e9e9e' }} />
                              </Box>
                            </Box>
                            <Typography variant="h5">
                              {state.diagnostics.odometer
                                ? `${Math.round(state.diagnostics.odometer).toLocaleString()} mi`
                                : 'N/A'}
                            </Typography>
                          </Paper>
                        </Grid>

                        {/* Engine Hours */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Paper
                            elevation={1}
                            style={{ padding: 16, cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                            onClick={() => handleOpenHistoryChart('engineHours')}
                            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'}
                            onMouseOut={(e) => e.currentTarget.style.boxShadow = ''}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                              <Box display="flex" alignItems="center">
                                <TimerIcon color="primary" style={{ marginRight: 8 }} />
                                <Typography variant="subtitle2">Engine Hours</Typography>
                              </Box>
                              <Box display="flex" alignItems="center">
                                {state.diagnostics.ages?.engineHours != null && (
                                  <Typography variant="caption" style={{ color: state.diagnostics.ages.engineHours > 24 ? '#ff9800' : '#9e9e9e', fontSize: '0.7rem', marginRight: 4 }}>
                                    {state.diagnostics.ages.engineHours}h ago
                                  </Typography>
                                )}
                                <TimelineIcon style={{ fontSize: 14, color: '#9e9e9e' }} />
                              </Box>
                            </Box>
                            <Typography variant="h5">
                              {state.diagnostics.engineHours
                                ? `${Math.round(state.diagnostics.engineHours).toLocaleString()} hrs`
                                : 'N/A'}
                            </Typography>
                          </Paper>
                        </Grid>

                        {/* Fuel Level */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Paper
                            elevation={1}
                            style={{ padding: 16, cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                            onClick={() => handleOpenHistoryChart('fuelLevel')}
                            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'}
                            onMouseOut={(e) => e.currentTarget.style.boxShadow = ''}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                              <Box display="flex" alignItems="center">
                                <FuelIcon color="primary" style={{ marginRight: 8 }} />
                                <Typography variant="subtitle2">Fuel Level</Typography>
                              </Box>
                              <Box display="flex" alignItems="center">
                                {state.diagnostics.ages?.fuelLevel != null && (
                                  <Typography variant="caption" style={{ color: state.diagnostics.ages.fuelLevel > 24 ? '#ff9800' : '#9e9e9e', fontSize: '0.7rem', marginRight: 4 }}>
                                    {state.diagnostics.ages.fuelLevel}h ago
                                  </Typography>
                                )}
                                <TimelineIcon style={{ fontSize: 14, color: '#9e9e9e' }} />
                              </Box>
                            </Box>
                            <Typography variant="h5">
                              {state.diagnostics.fuelLevel != null
                                ? `${Math.round(state.diagnostics.fuelLevel)}%`
                                : 'N/A'}
                            </Typography>
                            {state.diagnostics.fuelLevel != null && (
                              <Box
                                mt={1}
                                height={8}
                                bgcolor="grey.200"
                                borderRadius={4}
                                overflow="hidden"
                              >
                                <Box
                                  height="100%"
                                  width={`${state.diagnostics.fuelLevel}%`}
                                  bgcolor={state.diagnostics.fuelLevel < 20 ? 'error.main' : 'success.main'}
                                />
                              </Box>
                            )}
                          </Paper>
                        </Grid>

                        {/* Battery Voltage */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Paper
                            elevation={1}
                            style={{ padding: 16, cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                            onClick={() => handleOpenHistoryChart('batteryVoltage')}
                            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'}
                            onMouseOut={(e) => e.currentTarget.style.boxShadow = ''}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                              <Box display="flex" alignItems="center">
                                <BatteryIcon
                                  style={{
                                    marginRight: 8,
                                    color: state.diagnostics.batteryVoltage < 12 ? '#f44336' : '#4caf50'
                                  }}
                                />
                                <Typography variant="subtitle2">Battery Voltage</Typography>
                              </Box>
                              <Box display="flex" alignItems="center">
                                {state.diagnostics.ages?.batteryVoltage != null && (
                                  <Typography variant="caption" style={{ color: state.diagnostics.ages.batteryVoltage > 24 ? '#ff9800' : '#9e9e9e', fontSize: '0.7rem', marginRight: 4 }}>
                                    {state.diagnostics.ages.batteryVoltage}h ago
                                  </Typography>
                                )}
                                <TimelineIcon style={{ fontSize: 14, color: '#9e9e9e' }} />
                              </Box>
                            </Box>
                            <Typography
                              variant="h5"
                              style={{ color: state.diagnostics.batteryVoltage < 12 ? '#f44336' : 'inherit' }}
                            >
                              {state.diagnostics.batteryVoltage
                                ? `${state.diagnostics.batteryVoltage.toFixed(1)} V`
                                : 'N/A'}
                            </Typography>
                            {state.diagnostics.batteryVoltage && state.diagnostics.batteryVoltage < 12 && (
                              <Typography variant="caption" color="error">Low battery warning</Typography>
                            )}
                          </Paper>
                        </Grid>

                        {/* Oil Life */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Paper
                            elevation={1}
                            style={{ padding: 16, cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                            onClick={() => handleOpenHistoryChart('oilLife')}
                            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'}
                            onMouseOut={(e) => e.currentTarget.style.boxShadow = ''}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                              <Box display="flex" alignItems="center">
                                <OilIcon color="primary" style={{ marginRight: 8 }} />
                                <Typography variant="subtitle2">Oil Life</Typography>
                              </Box>
                              <Box display="flex" alignItems="center">
                                {state.diagnostics.ages?.oilLife != null && (
                                  <Typography variant="caption" style={{ color: state.diagnostics.ages.oilLife > 24 ? '#ff9800' : '#9e9e9e', fontSize: '0.7rem', marginRight: 4 }}>
                                    {state.diagnostics.ages.oilLife}h ago
                                  </Typography>
                                )}
                                <TimelineIcon style={{ fontSize: 14, color: '#9e9e9e' }} />
                              </Box>
                            </Box>
                            <Typography
                              variant="h5"
                              style={{ color: state.diagnostics.oilLife != null && state.diagnostics.oilLife < 20 ? '#ff9800' : 'inherit' }}
                            >
                              {state.diagnostics.oilLife != null
                                ? `${Math.round(state.diagnostics.oilLife)}%`
                                : 'N/A'}
                            </Typography>
                            {state.diagnostics.oilLife != null && state.diagnostics.oilLife < 20 && (
                              <Typography variant="caption" style={{ color: '#ff9800' }}>Oil change recommended</Typography>
                            )}
                          </Paper>
                        </Grid>

                        {/* Coolant Temp */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Paper
                            elevation={1}
                            style={{ padding: 16, cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                            onClick={() => handleOpenHistoryChart('coolantTemp')}
                            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'}
                            onMouseOut={(e) => e.currentTarget.style.boxShadow = ''}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                              <Box display="flex" alignItems="center">
                                <TempIcon
                                  style={{
                                    marginRight: 8,
                                    color: state.diagnostics.coolantTemp > 230 ? '#f44336' : '#2196f3'
                                  }}
                                />
                                <Typography variant="subtitle2">Coolant Temp</Typography>
                              </Box>
                              <Box display="flex" alignItems="center">
                                {state.diagnostics.ages?.coolantTemp != null && (
                                  <Typography variant="caption" style={{ color: state.diagnostics.ages.coolantTemp > 24 ? '#ff9800' : '#9e9e9e', fontSize: '0.7rem', marginRight: 4 }}>
                                    {state.diagnostics.ages.coolantTemp}h ago
                                  </Typography>
                                )}
                                <TimelineIcon style={{ fontSize: 14, color: '#9e9e9e' }} />
                              </Box>
                            </Box>
                            <Typography
                              variant="h5"
                              style={{ color: state.diagnostics.coolantTemp > 230 ? '#f44336' : 'inherit' }}
                            >
                              {state.diagnostics.coolantTemp
                                ? `${Math.round(state.diagnostics.coolantTemp)}°F`
                                : 'N/A'}
                            </Typography>
                            {state.diagnostics.coolantTemp > 230 && (
                              <Typography variant="caption" color="error">Overheating warning</Typography>
                            )}
                          </Paper>
                        </Grid>

                        {/* Oil Pressure */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Paper
                            elevation={1}
                            style={{ padding: 16, cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                            onClick={() => handleOpenHistoryChart('oilPressure')}
                            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'}
                            onMouseOut={(e) => e.currentTarget.style.boxShadow = ''}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                              <Box display="flex" alignItems="center">
                                <OilIcon color="primary" style={{ marginRight: 8 }} />
                                <Typography variant="subtitle2">Oil Pressure</Typography>
                              </Box>
                              <Box display="flex" alignItems="center">
                                {state.diagnostics.ages?.oilPressure != null && (
                                  <Typography variant="caption" style={{ color: state.diagnostics.ages.oilPressure > 24 ? '#ff9800' : '#9e9e9e', fontSize: '0.7rem', marginRight: 4 }}>
                                    {state.diagnostics.ages.oilPressure}h ago
                                  </Typography>
                                )}
                                <TimelineIcon style={{ fontSize: 14, color: '#9e9e9e' }} />
                              </Box>
                            </Box>
                            <Typography variant="h5">
                              {state.diagnostics.oilPressure != null
                                ? `${Math.round(state.diagnostics.oilPressure)} psi`
                                : 'N/A'}
                            </Typography>
                          </Paper>
                        </Grid>

                        {/* Electrical System Rating (ESR) */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Paper
                            elevation={1}
                            style={{ padding: 16, cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                            onClick={() => handleOpenHistoryChart('electricalSystemRating')}
                            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'}
                            onMouseOut={(e) => e.currentTarget.style.boxShadow = ''}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                              <Box display="flex" alignItems="center">
                                <BatteryIcon
                                  style={{
                                    marginRight: 8,
                                    color: state.diagnostics.electricalSystemRating != null && state.diagnostics.electricalSystemRating < 50 ? '#ff9800' : '#4caf50'
                                  }}
                                />
                                <Typography variant="subtitle2">Electrical System (ESR)</Typography>
                              </Box>
                              <Box display="flex" alignItems="center">
                                {state.diagnostics.ages?.electricalSystemRating != null && (
                                  <Typography variant="caption" style={{ color: state.diagnostics.ages.electricalSystemRating > 24 ? '#ff9800' : '#9e9e9e', fontSize: '0.7rem', marginRight: 4 }}>
                                    {state.diagnostics.ages.electricalSystemRating}h ago
                                  </Typography>
                                )}
                                <TimelineIcon style={{ fontSize: 14, color: '#9e9e9e' }} />
                              </Box>
                            </Box>
                            <Typography
                              variant="h5"
                              style={{ color: state.diagnostics.electricalSystemRating != null && state.diagnostics.electricalSystemRating < 50 ? '#ff9800' : 'inherit' }}
                            >
                              {state.diagnostics.electricalSystemRating != null
                                ? `${Math.round(state.diagnostics.electricalSystemRating)}%`
                                : 'N/A'}
                            </Typography>
                            {state.diagnostics.electricalSystemRating != null && (
                              <Box mt={1} height={8} bgcolor="grey.200" borderRadius={4} overflow="hidden">
                                <Box
                                  height="100%"
                                  width={`${state.diagnostics.electricalSystemRating}%`}
                                  bgcolor={state.diagnostics.electricalSystemRating < 50 ? 'warning.main' : 'success.main'}
                                />
                              </Box>
                            )}
                            {state.diagnostics.electricalSystemRating != null && state.diagnostics.electricalSystemRating < 50 && (
                              <Typography variant="caption" style={{ color: '#ff9800' }}>Battery health concern</Typography>
                            )}
                          </Paper>
                        </Grid>

                        {/* Tire Pressures */}
                        {state.diagnostics.tirePressure && (
                          <Grid item xs={12}>
                            <Paper elevation={1} style={{ padding: 16 }}>
                              <Typography variant="subtitle2" gutterBottom>
                                Tire Pressure (PSI)
                              </Typography>
                              <Grid container spacing={2}>
                                {/* Front Left */}
                                <Grid item xs={6} sm={3}>
                                  <Box textAlign="center" p={1} bgcolor="grey.100" borderRadius={4}>
                                    <Typography variant="caption" color="textSecondary">
                                      Front Left
                                    </Typography>
                                    <Typography variant="h6">
                                      {state.diagnostics.tirePressure.frontLeft
                                        ? Math.round(state.diagnostics.tirePressure.frontLeft)
                                        : '--'}
                                    </Typography>
                                    {state.diagnostics.tirePressure.timestamps?.frontLeft && (
                                      <Typography
                                        variant="caption"
                                        style={{
                                          fontSize: '0.65rem',
                                          color: (Date.now() - new Date(state.diagnostics.tirePressure.timestamps.frontLeft)) / (1000 * 60 * 60) > 24 ? '#ff9800' : '#9e9e9e'
                                        }}
                                      >
                                        {moment(state.diagnostics.tirePressure.timestamps.frontLeft).fromNow()}
                                      </Typography>
                                    )}
                                  </Box>
                                </Grid>
                                {/* Front Right */}
                                <Grid item xs={6} sm={3}>
                                  <Box textAlign="center" p={1} bgcolor="grey.100" borderRadius={4}>
                                    <Typography variant="caption" color="textSecondary">
                                      Front Right
                                    </Typography>
                                    <Typography variant="h6">
                                      {state.diagnostics.tirePressure.frontRight
                                        ? Math.round(state.diagnostics.tirePressure.frontRight)
                                        : '--'}
                                    </Typography>
                                    {state.diagnostics.tirePressure.timestamps?.frontRight && (
                                      <Typography
                                        variant="caption"
                                        style={{
                                          fontSize: '0.65rem',
                                          color: (Date.now() - new Date(state.diagnostics.tirePressure.timestamps.frontRight)) / (1000 * 60 * 60) > 24 ? '#ff9800' : '#9e9e9e'
                                        }}
                                      >
                                        {moment(state.diagnostics.tirePressure.timestamps.frontRight).fromNow()}
                                      </Typography>
                                    )}
                                  </Box>
                                </Grid>
                                {/* Rear Left */}
                                <Grid item xs={6} sm={3}>
                                  <Box textAlign="center" p={1} bgcolor="grey.100" borderRadius={4}>
                                    <Typography variant="caption" color="textSecondary">
                                      Rear Left
                                    </Typography>
                                    <Typography variant="h6">
                                      {state.diagnostics.tirePressure.rearLeft
                                        ? Math.round(state.diagnostics.tirePressure.rearLeft)
                                        : '--'}
                                    </Typography>
                                    {state.diagnostics.tirePressure.timestamps?.rearLeft && (
                                      <Typography
                                        variant="caption"
                                        style={{
                                          fontSize: '0.65rem',
                                          color: (Date.now() - new Date(state.diagnostics.tirePressure.timestamps.rearLeft)) / (1000 * 60 * 60) > 24 ? '#ff9800' : '#9e9e9e'
                                        }}
                                      >
                                        {moment(state.diagnostics.tirePressure.timestamps.rearLeft).fromNow()}
                                      </Typography>
                                    )}
                                  </Box>
                                </Grid>
                                {/* Rear Right */}
                                <Grid item xs={6} sm={3}>
                                  <Box textAlign="center" p={1} bgcolor="grey.100" borderRadius={4}>
                                    <Typography variant="caption" color="textSecondary">
                                      Rear Right
                                    </Typography>
                                    <Typography variant="h6">
                                      {state.diagnostics.tirePressure.rearRight
                                        ? Math.round(state.diagnostics.tirePressure.rearRight)
                                        : '--'}
                                    </Typography>
                                    {state.diagnostics.tirePressure.timestamps?.rearRight && (
                                      <Typography
                                        variant="caption"
                                        style={{
                                          fontSize: '0.65rem',
                                          color: (Date.now() - new Date(state.diagnostics.tirePressure.timestamps.rearRight)) / (1000 * 60 * 60) > 24 ? '#ff9800' : '#9e9e9e'
                                        }}
                                      >
                                        {moment(state.diagnostics.tirePressure.timestamps.rearRight).fromNow()}
                                      </Typography>
                                    )}
                                  </Box>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>
                        )}
                      </Grid>

                      {/* Geotab Info */}
                      <Box mt={3}>
                        <Typography variant="caption" color="textSecondary">
                          Geotab Device: {state.equipment.geoTabName || '' } {`(${state.equipment.geoTabId})` || ''} 
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    <Box textAlign="center" p={4}>
                      <Typography color="textSecondary" gutterBottom>
                        No diagnostics data available yet.
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Click "Refresh from Geotab" to fetch the latest diagnostics,
                        or wait for the nightly sync.
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<RefreshIcon />}
                        onClick={handleRefreshDiagnostics}
                        disabled={state.refreshingDiagnostics}
                        style={{ marginTop: 16 }}
                      >
                        Fetch Diagnostics Now
                      </Button>
                    </Box>
                  )}
                </TabPanel>
              )}

              <TabPanel value={tabValue} index={state.equipment.type === 'Key' ? 1 : (state.equipment.type === 'Vehicle' && state.equipment.geoTabId ? 5 : 4)} className={classes.tabPanel}>
                <Box className={classes.fieldGroup}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    Notes
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    label="Equipment Notes"
                    value={state.equipment.notes || ''}
                    onChange={(e) => setState({...state, equipment: {...state.equipment, notes: e.target.value}})}
                  />
                </Box>

                <Box className={classes.fieldGroup}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    Settings
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.isActive}
                        onChange={(e) => setState({
                          ...state,
                          isActive: !state.isActive,
                          equipment: {...state.equipment, isActive: !state.isActive}
                        })}
                      />
                    }
                    label={state.isActive ? 'Equipment Active' : 'Equipment Inactive'}
                  />
                </Box>

                  <Box className={classes.fieldGroup}>
                    <Typography variant="h6" className={classes.sectionTitle}>
                      QR Code
                    </Typography>
                    <TextField
                      fullWidth
                      label="Custom QR Code"
                      value={state.equipment.qrCode || ''}
                      onChange={(e) => setState({
                        ...state,
                        customQR: e.target.value,
                        equipment: {...state.equipment, qrCode: e.target.value}
                      })}
                    />
                  </Box>
          
              </TabPanel>
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseModal}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>

    {/* Diagnostic History Chart Dialog */}
    <Dialog
      open={state.historyChartOpen}
      onClose={handleCloseHistoryChart}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <TimelineIcon style={{ marginRight: 8, color: metricConfig[state.historyChartMetric]?.color || '#2196f3' }} />
            <Typography variant="h6">
              {metricConfig[state.historyChartMetric]?.label || state.historyChartMetric} History
            </Typography>
          </Box>
          <IconButton onClick={handleCloseHistoryChart} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        {state.historyChartDateRange && (
          <Typography variant="caption" color="textSecondary">
            Data from {state.historyChartDateRange.oldest ? moment(state.historyChartDateRange.oldest).format('MMM DD, YYYY') : 'N/A'} to {state.historyChartDateRange.newest ? moment(state.historyChartDateRange.newest).format('MMM DD, YYYY') : 'now'}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        {state.historyChartLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
            <CircularProgress />
          </Box>
        ) : state.historyChartData.length === 0 ? (
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight={300}>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              No historical data available for this metric
            </Typography>
            <Typography variant="caption" color="textSecondary">
              Data will be collected as the vehicle reports diagnostics over time
            </Typography>
          </Box>
        ) : (
          <Box>
            {/* Summary stats */}
            <Box display="flex" justifyContent="space-around" mb={2} p={2} bgcolor="grey.50" borderRadius={1}>
              <Box textAlign="center">
                <Typography variant="caption" color="textSecondary">Latest</Typography>
                <Typography variant="h6">
                  {state.historyChartData.length > 0 ? (
                    `${state.historyChartData[state.historyChartData.length - 1].value} ${metricConfig[state.historyChartMetric]?.unit || ''}`
                  ) : 'N/A'}
                </Typography>
              </Box>
              <Box textAlign="center">
                <Typography variant="caption" color="textSecondary">Min</Typography>
                <Typography variant="h6">
                  {state.historyChartData.length > 0 ? (
                    `${Math.min(...state.historyChartData.map(d => d.value)).toFixed(1)} ${metricConfig[state.historyChartMetric]?.unit || ''}`
                  ) : 'N/A'}
                </Typography>
              </Box>
              <Box textAlign="center">
                <Typography variant="caption" color="textSecondary">Max</Typography>
                <Typography variant="h6">
                  {state.historyChartData.length > 0 ? (
                    `${Math.max(...state.historyChartData.map(d => d.value)).toFixed(1)} ${metricConfig[state.historyChartMetric]?.unit || ''}`
                  ) : 'N/A'}
                </Typography>
              </Box>
              <Box textAlign="center">
                <Typography variant="caption" color="textSecondary">Data Points</Typography>
                <Typography variant="h6">{state.historyChartData.length}</Typography>
              </Box>
            </Box>

            {/* Chart */}
            <ResponsiveContainer width="100%" height={350}>
              <LineChart data={state.historyChartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                <XAxis
                  dataKey="dateLabel"
                  tick={{ fontSize: 11 }}
                  interval="preserveStartEnd"
                />
                <YAxis
                  domain={[
                    metricConfig[state.historyChartMetric]?.min || 'auto',
                    metricConfig[state.historyChartMetric]?.max || 'auto'
                  ]}
                  tick={{ fontSize: 11 }}
                  tickFormatter={(value) => `${value}${metricConfig[state.historyChartMetric]?.unit || ''}`}
                />
                <RechartsTooltip
                  formatter={(value) => [`${value} ${metricConfig[state.historyChartMetric]?.unit || ''}`, metricConfig[state.historyChartMetric]?.label]}
                  labelFormatter={(label) => `Time: ${label}`}
                  contentStyle={{ backgroundColor: 'white', border: '1px solid #ccc', borderRadius: 4 }}
                />
                {metricConfig[state.historyChartMetric]?.warning && (
                  <ReferenceLine
                    y={metricConfig[state.historyChartMetric].warning}
                    stroke="#ff9800"
                    strokeDasharray="5 5"
                    label={{ value: 'Warning', fill: '#ff9800', fontSize: 11 }}
                  />
                )}
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke={metricConfig[state.historyChartMetric]?.color || '#2196f3'}
                  strokeWidth={2}
                  dot={{ r: 3 }}
                  activeDot={{ r: 6 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseHistoryChart} color="default">
          Close
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user,
  notification: state.notification
});

export default connect(mapStateToProps)(EquipmentModal);
